<template>
  <div class="record_panel" @click="gotoDetail">
    <div class="header">
      <img :src="record.user.avatar_url" class="headimg">
      <div class="info">
        <div class="name">{{ record.user.nickname }}</div>
        <div class="time">{{ record.add_time_format }}</div>
      </div>
      <div v-if="hasMore" class="more">
        <van-icon name="ellipsis" @click.stop="onMore" />
      </div>
    </div>
    <div class="body">
      <div class="intro">{{ record.intro }}</div>
      <multi-img :images="record.picture_list" />
      <div class="desc">
        <van-tag v-if="record.is_country" size="medium" type="danger">越野</van-tag>
        跑步{{ record.distance_format }}公里，用时{{ record.duration_format }}，配速{{ record.pace_format }}
      </div>
    </div>
    <div v-if="hasFooter && record.clazz" class="footer" @click.stop="gotoClazz">
      <img class="cover" :src="record.clazz.cover_url">
      <div class="title">{{ record.clazz.clazz_name }}</div>
      <van-icon class="goto" name="arrow"/>
    </div>
    <div v-if="hasToolbar" class="review_toolbar">
      <div class="btn red" @click="allow">通过</div>
      <div class="btn" @click="deny">拒绝</div>
    </div>
    <div v-if="hasToolbar2" class="review_toolbar">
      <div class="btn red" @click="reallow">重新通过</div>
    </div>
    <div class="after_border" style="padding-bottom:15px;"></div>

    <van-actionsheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      @select="onSelect"
    />
  </div>
</template>

<script>
import { Icon, Tag, Dialog, Actionsheet, Toast } from 'vant'
import MultiImg from './MultiImg'
import { recordReview, recordDelete, recordRepass } from '@/api/record'

export default {
  name: 'RecordPanel',
  components: {
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Dialog.name]: Dialog,
    [Actionsheet.name]: Actionsheet,
    MultiImg
  },
  props: {
    record: {
      type: Object
    },
    hasFooter: {
      type: Boolean,
      default: false
    },
    hasToolbar: {
      type: Boolean,
      default: false
    },
    hasToolbar2: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  data () {
    return {
      show: false,
      actions: [
        { name: '打卡海报', index: 1 },
        { name: '删除', index: 2 }
      ],
      reject_reason: ''
    }
  },
  methods: {
    allow () {
      Dialog.confirm({
        title: '审核通过',
        message: '确定通过该记录？'
      }).then(async () => {
        Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
        await recordReview(this.record.uuid, {
          review_status: 2,
          reject_reason: ''
        })
        Toast.clear()
        setTimeout(() => {
          this.$emit('refresh', this.record)
        }, 500)
      }).catch(() => {
      })
    },
    deny () {
      Dialog.confirm({
        title: '审核拒绝',
        message: '确定拒绝该记录？'
      }).then(async () => {
        Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
        await recordReview(this.record.uuid, {
          review_status: 3,
          reject_reason: ''
        })
        Toast.clear()
        setTimeout(() => {
          this.$emit('refresh', this.record)
        }, 500)
      }).catch(() => {
      })
    },
    reallow () {
      Dialog.confirm({
        title: '审核通过',
        message: '确定通过该记录？'
      }).then(async () => {
        await recordRepass(this.record.uuid)
        setTimeout(() => {
          this.$emit('refresh', this.record)
        }, 500)
      }).catch(() => {
      })
    },
    delete () {
      Dialog.confirm({
        title: '删除记录',
        message: '删除后不可恢复，并且会清除当天打卡记录'
      }).then(async () => {
        Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
        await recordDelete(this.record.uuid)
        Toast.clear()
        setTimeout(() => {
          this.$emit('delete', this.record)
        }, 500)
      }).catch(() => {
      })
    },
    onMore () {
      this.show = true
    },
    onSelect (item) {
      this.show = false
      if (item.index === 1) {
        this.$router.push(`/daka/poster?record_id=${this.record.uuid}`)
      } else if (item.index === 2) {
        this.delete()
      }
    },
    gotoDetail () {
      // this.$router.push('/record/' + this.record.uuid + '/detail')
    },
    gotoClazz () {
      this.$router.push('/clazz/' + this.record.clazz.uuid)
    }
  }
}
</script>

<style scoped lang="scss">
.record_panel {
  padding: 25px 15px 0;
  .header {
    display: flex;
    .headimg {
      width: 90px;
      height: 90px;
      border-radius: 50%;
    }
    .info {
      margin-left: 20px;
      width: 550px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .name {
        font-size: 30px;
      }
      .time {
        color: #bbb;
        font-size: 26px;
      }
    }
    .more {
      color: #bbb;
    }
  }
  .body {
    margin-left: 110px;
    margin-top: 20px;
    width: 560px;
    font-size: 26px;
  }
  .review_toolbar {
    height: 70px;
    padding-right: 30px;
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .btn {
      width: 120px;
      height: 45px;
      font-size: 24px;
      border-radius: 25px;
      border: 1PX solid #7d7e80;
      color: #7d7e80;
      margin-left: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      &.red {
        border: 1PX solid #f5222d;
        color: #f5222d;
      }
    }
  }
  .footer {
    margin-left: 110px;
    margin-top: 20px;
    width: 560px;
    height: 100px;
    background-color: #f8f8f8;
    display: flex;
    align-items: center;
    font-size: 26px;
    .cover {
      width: 100px;
      height: 100px;
      object-fit: cover;
    }
    .title {
      margin-left: 10px;
      width: 400px;
    }
    .goto {
      width: 30px;
    }
  }
}
.full_popup {
  width: 100%;
  height: 100%;
}
</style>
